import React from "react";
import siteConfig from "../siteConfig";

/**
 * "Request FREE Estimate" + click-to-call pair. The Wyoming design (Figma node
 * 428:38) repeats this pair four times down the page, so it lives here once.
 *
 * The phone number is resolved per city from siteConfig rather than passed in:
 * Wyoming and Jackson answer on their own lines, and every other city on the
 * Battle Creek number. The design writes the number as "(616)-367-3700"; we use
 * siteConfig's "(616) 367-3700" so the page matches the header, footer and
 * LocalBusiness schema — mixed NAP formatting works against local SEO.
 *
 * The estimate button targets #estimate, the hero form (see service-hero.js),
 * matching the convention already used on the homepage and About page.
 */
const CityCtaPair = ({ city, className = "", align = "left" }) => {
  const phone = siteConfig.phoneForCity(city);
  const base =
    "inline-flex items-center justify-center h-12 px-4 rounded-xl font-display font-semibold text-base no-underline transition-colors";

  return (
    <div
      className={`flex flex-wrap items-center gap-4 sm:gap-8 ${
        align === "center" ? "justify-center" : ""
      } ${className}`}
    >
      <a href="#estimate" className={`${base} bg-neutral-900 text-white hover:bg-neutral-800`}>
        Request FREE Estimate
      </a>
      <a
        href={`tel:${siteConfig.phoneE164(phone)}`}
        className={`${base} bg-brand-600 text-white hover:bg-brand-700`}
        aria-label={`Call the ${String(city || "").trim()} office at ${phone}`}
      >
        {phone}
      </a>
    </div>
  );
};

export default CityCtaPair;
